﻿namespace WebPortal.Navigation {

    export class NavigationMessage {

        private messagePool: Array<JQuery> = [];

        public show(buttonName: string, msg: any): void
        public show(buttonName: string, msg: any, timeout: number): void
        public show(buttonName: string, msg: any, timeout: number, withBackgroundBlur: boolean): void
        public show(buttonName: string, msg: any, timeout: number = 5000, withBackgroundBlur: boolean = false): void {
            let messageData: any = this.convertToMessageObject(msg, timeout, withBackgroundBlur);
            let buttonPosition: any = this.getButtonPosition(buttonName);
            let message: JQuery = this.prepareMessage(messageData, buttonPosition);

            if (message.hasClass("hidden")) {
                message.removeClass("hidden");
            }

            // sparkView Fehlermeldungen haben kein Timeout
            if (timeout && timeout !== 0) {
                setTimeout(() => {
                    this.destroy(null, message);
                }, timeout);
            }
        }

        public hide(message: JQuery): void {
            if (message) {
                this.destroy(null, message);
            }
        }

        private getButtonPosition(buttonName: string): any {
            let button: JQuery = navigationUtils.getButton(buttonName);
            if (!button.length) {
                console.warn("No Button Info found, take Notification");
                buttonName = "Notification";
                button = navigationUtils.getButton(buttonName);
            }

            let buttonPosition: any = button.position();
            buttonPosition.height = button.height();
            buttonPosition.buttonName = buttonName;

            if (navigationController.isNavCollapsed) {
                buttonPosition.left = 55;
            } else {
                buttonPosition.left = 300;
            }
            return buttonPosition;
        }

        private convertToMessageObject(_msg: any, _timeout: number, _withBackgroundBlur: boolean): any {
            let messageData: any =
                (typeof _msg === "string") ?
                    { msg: _msg, title: "", withBackgroundBlur: _withBackgroundBlur, timeout: _timeout, count: 1 } :
                    _msg;

            if (!messageData.timeout) {
                messageData.timeout = (_timeout || _timeout === 0) ? _timeout : 0;
            }

            if (!messageData.withBackgroundBlur) {
                messageData.withBackgroundBlur = _withBackgroundBlur ? _withBackgroundBlur : false;
            }

            return messageData;
        }

        private prepareMessage(messageData: any, buttonPosition: any): JQuery {

            // überprüfe nach gleichem Message Typ und gleichem Inhalt
            for (let i: number = 0; i < this.messagePool.length; i++) {
                let message: JQuery = this.messagePool[i];

                // position für die nächste Message anpassen  
                if (message.attr("buttonName") === buttonPosition.buttonName) {
                    if (navigationController.isNavCollapsed) {
                        buttonPosition.top += (buttonPosition.height + 8);
                    } else {
                        buttonPosition.top += (buttonPosition.height + 15);
                    }
                    messageData.sameMessageType = true;

                    // message mit gleichem Inhalt wird hochgezählt und Funktion wird abgebrochen
                    let messageContent: JQuery = message.children("div").children("#nav_status_info_content");
                    if (messageData.msg === messageContent.text()) {
                        message.trigger("addCount", [messageData.count]);
                        return message;
                    }
                }
            }

            // neue Message erstellen
            return this.createNewMessage(messageData, buttonPosition);
        }

        private createNewMessage(messageData: any, buttonPosition: any): JQuery {
            let timestamp: number = new Date().getTime();

            let message: JQuery = $("<div>")
                .attr({
                    "id": "pn_nav_status_info_" + buttonPosition.buttonName + "_" + timestamp,
                    "class": "container-fluid status-info hidden",
                    "messageCount": 1,
                    "buttonName": buttonPosition.buttonName,
                    "sameMessageType": messageData.sameMessageType
                }).css({
                    "left": buttonPosition.left + 10,
                    "top": buttonPosition.top,
                    "min-height": buttonPosition.height === 0 ? (navigationController.isNavCollapsed ? 48 : 40) : buttonPosition.height
                });

            let messageArrow: JQuery = $("<div>").attr({
                "id": "nav_status_info_arrow",
                "class": messageData.sameMessageType ?
                    "tooltip-arrow status-info-arrow arrow-top" :
                    "tooltip-arrow status-info-arrow arrow-left",
            });

            let messageBody: JQuery = $("<div>").attr({
                "id": "nav_status_info_body",
                "class": "status-info-body"
            });

            if (!navigationController.isNavCollapsed) {
                message.css({ "padding": 10 });
                messageArrow.css({ "margin-left": -23 });
            }

            let messageContent: JQuery = $("<div>").attr({
                "id": "nav_status_info_content",
                "class": "status-info-content"
                // "class": "status-info-content col-xs-12 col-sm-11 col-md-11"
            }).html(messageData.msg);

            let messageCounter: JQuery = $("<div>").attr({
                "id": "nav_status_info_counter",
                "class": "status-info-counter"
            });

            messageBody.append(messageContent).append(messageCounter);
            message.append(messageArrow).append(messageBody);
            message.appendTo("body");

            // add handlers
            this.attachHandlers(message, messageCounter);

            // add to pool
            this.messagePool.push(message);

            return message;
        }

        private attachHandlers(message: JQuery, messageCounter: JQuery): void {
            message.on("click", (e: JQueryEventObject) => { this.destroy(e); });
            message.on("addCount", (event: JQueryEventObject, count: any) => {
                count = count || 1;
                message.attr({ "messageCount": parseInt(message.attr("messageCount")) + count });
                messageCounter.html("(" + message.attr("messageCount") + ")");
            });
        }

        private destroy(event: Event, message: JQuery = null): void {
            if (message && message.length > 0) {
                this.reposition(message);
                this.remove(message);

            } else {
                this.reposition($(event.currentTarget));
                this.remove($(event.currentTarget));
            }
        }

        private reposition(message: JQuery): void {

            // pendente Messages die neu positioniert werden müssen
            let tmpOldMessagePositions: Array<number> = [];

            for (let i: number = 0; i < this.messagePool.length; i++) {

                // vom gleichen Button
                if (this.messagePool[i].attr("buttonName") === message.attr("buttonName")) {

                    // die Message darf nicht sich selbst sein
                    if (this.messagePool[i].attr("id") !== message.attr("id")) {
                        let deletedMessagePosition: any = message.position();
                        let existingMessagePosition: any = this.messagePool[i].position();

                        // falls die Position des gelöschten Messages kleiner ist als die Restlichen, muss neu positioniert werden
                        if (deletedMessagePosition.top < existingMessagePosition.top) {

                            // falls noch weitere Messages neu positioniert werden müssen
                            if (tmpOldMessagePositions.length > 0) {
                                let nextOldMessagePosition: number = tmpOldMessagePositions.shift();
                                if (nextOldMessagePosition) {
                                    this.messagePool[i].css({
                                        "top": nextOldMessagePosition
                                    });
                                }
                            } else {

                                // aktuelle Message erhält die Position der gelöschten Message
                                this.messagePool[i].css({
                                    "top": message.css("top")
                                });
                            }

                            tmpOldMessagePositions.push(existingMessagePosition.top);
                        }
                    }
                }
            }
            tmpOldMessagePositions.length = 0;
        }

        private remove(message: JQuery): void {

            for (let i: number = 0; i < this.messagePool.length; i++) {
                if (this.messagePool[i].attr("id") === message.attr("id")) {
                    this.messagePool.splice(i, 1);
                    message.remove();

                    // arrow für die oberste Element anpassen
                    if (this.messagePool.length > 0) {
                        this.messagePool[0].children("#nav_status_info_arrow").removeClass("arrow-top").addClass("arrow-left");
                    }

                    break;
                }
            }
        }
    }
}